module.exports = __webpack_public_path__ + "static/media/h5_game_market_selector.475568e7.png";